import React from 'react';
import NomenklaturaRep from '../../components/reports/nomenklatura/NomenklaturaRep'


function NomenklaturaRepPage(props) {
    return (
        <>
            <NomenklaturaRep/>
        </>
    );
}

export default NomenklaturaRepPage;